module.exports = __webpack_public_path__ + "img/marie_claire.1c932f3.png";